module.exports = __webpack_public_path__ + "95d5906b5ac309e9ae3ad44c7a4ff951.svg";